function Step2DmrHomepageContent({
 templateState,
 setTemplateField,
 heroImageFile,
 setHeroImageFile,
 existingHeroImageUrl,
 removeHeroImage,
 setRemoveHeroImage,
}) {
 const featureCards = Array.isArray(templateState.feature_cards)
  ? templateState.feature_cards
  : [];

 const updateFeatureCard = (index, field, value) => {
  const next = [...featureCards];

  next[index] = {
   ...next[index],
   [field]: value,
  };

  setTemplateField("feature_cards", next);
 };

 return (
  <div className="card">
   <h2>DMR Homepage Content</h2>

   <h3>Hero Section</h3>

   <div className="row-2">
    <label className="field">
     <span>Season Label</span>
     <input
      value={templateState.season_label || ""}
      onChange={(e) =>
       setTemplateField("season_label", e.target.value)
      }
      placeholder="Season 1"
     />
    </label>

    <label className="field">
     <span>Hero Title</span>
     <input
      value={templateState.hero_title || ""}
      onChange={(e) =>
       setTemplateField("hero_title", e.target.value)
      }
      placeholder="DMR Tennis"
     />
    </label>
   </div>

   <div className="row-2">
    <label className="field">
     <span>Accent Title</span>
     <input
      value={templateState.hero_accent_title || ""}
      onChange={(e) =>
       setTemplateField(
        "hero_accent_title",
        e.target.value
       )
      }
      placeholder="Starts Here"
     />
    </label>

    <label className="field">
     <span>Hero Subtitle</span>
     <input
      value={templateState.hero_subtitle || ""}
      onChange={(e) =>
       setTemplateField("hero_subtitle", e.target.value)
      }
     />
    </label>
   </div>

   <div className="row-2">
    <label className="field">
     <span>Primary Button Text</span>
     <input
      value={templateState.primary_button_label || ""}
      onChange={(e) =>
       setTemplateField(
        "primary_button_label",
        e.target.value
       )
      }
     />
    </label>

    <label className="field">
     <span>Primary Button Link</span>
     <input
      value={templateState.primary_button_link || ""}
      onChange={(e) =>
       setTemplateField(
        "primary_button_link",
        e.target.value
       )
      }
     />
    </label>
   </div>

   <div className="row-2">
    <label className="field">
     <span>Secondary Button Text</span>
     <input
      value={templateState.secondary_button_label || ""}
      onChange={(e) =>
       setTemplateField(
        "secondary_button_label",
        e.target.value
       )
      }
     />
    </label>

    <label className="field">
     <span>Secondary Button Link</span>
     <input
      value={templateState.secondary_button_link || ""}
      onChange={(e) =>
       setTemplateField(
        "secondary_button_link",
        e.target.value
       )
      }
     />
    </label>
   </div>

   <div className="field">
    <span>Hero Image</span>

    {existingHeroImageUrl &&
     !heroImageFile &&
     !removeHeroImage ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Current hero image uploaded
      </span>

      <a
       href={existingHeroImageUrl}
       target="_blank"
       rel="noreferrer"
       className="existing-file-link"
      >
       View
      </a>

      <button
       type="button"
       className="existing-file-remove"
       onClick={() => {
        setRemoveHeroImage(true);
        setHeroImageFile(null);
       }}
      >
       Remove
      </button>
     </div>
    ) : null}

    {removeHeroImage ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Hero image will be removed
      </span>

      <button
       type="button"
       className="existing-file-link"
       onClick={() => setRemoveHeroImage(false)}
      >
       Undo
      </button>
     </div>
    ) : null}

    <div className="file-row">
     <input
      id="dmr-hero-upload"
      type="file"
      accept="image/*"
      className="file-hidden"
      onChange={(e) => {
       const file = e.target.files?.[0] || null;

       setHeroImageFile(file);

       if (file) {
        setRemoveHeroImage(false);
       }
      }}
     />

     <label
      htmlFor="dmr-hero-upload"
      className="file-btn"
     >
      Choose File
     </label>

     <div className="file-name">
      {heroImageFile?.name || "No file chosen"}
     </div>
    </div>
   </div>

   <hr />

   <h3>Features Section</h3>

   <div className="row-2">
    <label className="field">
     <span>Eyebrow</span>
     <input
      value={templateState.features_eyebrow || ""}
      onChange={(e) =>
       setTemplateField(
        "features_eyebrow",
        e.target.value
       )
      }
     />
    </label>

    <label className="field">
     <span>Section Title</span>
     <input
      value={templateState.features_title || ""}
      onChange={(e) =>
       setTemplateField(
        "features_title",
        e.target.value
       )
      }
     />
    </label>
   </div>

   {featureCards.map((card, index) => (
    <div
     key={index}
     className="card"
     style={{ marginBottom: 16 }}
    >
     <h4>Feature Card {index + 1}</h4>

     <div className="row-3">
      <label className="field">
       <span>Icon</span>
       <select
        value={card?.icon || "tennis"}
        onChange={(e) =>
         updateFeatureCard(
          index,
          "icon",
          e.target.value
         )
        }
       >
        <option value="calendar">Calendar</option>
        <option value="camera">Camera</option>
        <option value="chart">Chart</option>
        <option value="growth">Growth</option>
        <option value="player">Player</option>
        <option value="players">Players</option>
        <option value="racket">Racket</option>
        <option value="tennis">Tennis Ball</option>
        <option value="trophy">Trophy</option>
       </select>
      </label>

      <label className="field">
       <span>Title</span>
       <input
        value={card?.title || ""}
        onChange={(e) =>
         updateFeatureCard(
          index,
          "title",
          e.target.value
         )
        }
       />
      </label>

      <label className="field">
       <span>Description</span>
       <textarea
        rows={3}
        className="textarea"
        value={card?.description || ""}
        onChange={(e) =>
         updateFeatureCard(
          index,
          "description",
          e.target.value
         )
        }
       />
      </label>
     </div>
    </div>
   ))}
  </div>
 );
}

export default Step2DmrHomepageContent;